var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowRightBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 303,
    height: 74,
    viewBox: "0 0 303 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300.679 39.7553C302.598 37.7701 302.545 34.6047 300.559 32.6852L268.209 1.40555C266.223 -0.513923 263.058 -0.460634 261.139 1.52458C259.219 3.50979 259.272 6.67517 261.258 8.59464L290.014 36.3988L262.21 65.1552C260.29 67.1404 260.344 70.3058 262.329 72.2252C264.314 74.1447 267.479 74.0914 269.399 72.1062L300.679 39.7553ZM0.0839844 41.2798L0.168148 46.2791L297.168 41.2791L297.084 36.2798L297 31.2805L-0.00017879 36.2805L0.0839844 41.2798Z",
    fill: "#2A4169"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRightBig);
export default __webpack_public_path__ + "static/media/icon-arrow-right-big.ccea1393c302ecd3270fdb8bb9d4dba6.svg";
export { ForwardRef as ReactComponent };